import React from 'react'
import {Card, CardActionButton, CardHeader, SignInLayout} from '../components/SigninLayout'
import {FormattedMessage, useIntl} from "react-intl";

export const ActivationSuccess = ({system,token, newRegistration}) => {
  const intl = useIntl()
  return <SignInLayout system={system}>
    <Card centralizedContent>
      {
        newRegistration
          ? <CardHeader>
            <h1><FormattedMessage
              defaultMessage="Registration completed!"
              description="Registration success title"
            /></h1>
            <p><FormattedMessage
              defaultMessage="Thank you for completing your account information."
              description="Registration success message"
            /></p>
          </CardHeader>
          : <CardHeader>
            <h1><FormattedMessage
              defaultMessage="Registration update completed!"
              description="Registration update title"
            /></h1>
            <p><FormattedMessage
              defaultMessage="Thank you for updating your account information."
              description="Registration update message"
            /></p>
          </CardHeader>
      }
      <CardActionButton.a href={system.systemWebHooks.systemAuthWebHook+token + "&locale="+intl.locale} highlight>{
        system.labels.systemGoTo || <FormattedMessage
          defaultMessage="Go to case list"
          description="Account settings go to case list button"
        />
      }</CardActionButton.a>
    </Card>
  </SignInLayout>
}
